// SETTINGS CONSTANTS
export const LOGO_BG = "LOGO_BG";
export const NAVBAR_BG = "NAVBAR_BG";
export const SIDEBAR_BG = "SIDEBAR_BG";
export const THEME = "THEME";
export const DIRECTION = "DIRECTION";
export const SIDEBAR_POSITION = "SIDEBAR_POSITION";
export const HEADER_POSITION = "HEADER_POSITION";
export const LAYOUT = "LAYOUT";
export const SIDEBAR_TYPE = "SIDEBAR_TYPE";

// SESSION USER DETAIL
export const GET_SESSION_USER_DETAIL_REQUEST = 'GET_SESSION_USER_DETAIL_REQUEST';
export const GET_SESSION_USER_DETAIL_SUCCESS = 'GET_SESSION_USER_DETAIL_SUCCESS';
export const GET_SESSION_USER_DETAIL_FAILURE = 'GET_SESSION_USER_DETAIL_FAILURE';

// CUSTOMERS
export const GET_CUSTOMERS_REQUEST = "GET_CUSTOMERS_REQUEST";
export const GET_CUSTOMERS_SUCCESS = "GET_CUSTOMERS_SUCCESS";
export const GET_CUSTOMERS_FAILURE = "GET_CUSTOMERS_FAILURE";

// I-LINK STATUS
export const GET_ILINK_STATUS_REQUEST = "GET_ILINK_STATUS_REQUEST";
export const GET_ILINK_STATUS_SUCCESS = "GET_ILINK_STATUS_SUCCESS";
export const GET_ILINK_STATUS_FAILURE = "GET_ILINK_STATUS_FAILURE";
// export const POST_ILINK_STATUS_REQUEST = "POST_ILINK_STATUS_REQUEST";
// export const POST_ILINK_STATUS_SUCCESS = "POST_ILINK_STATUS_SUCCESS";
// export const POST_ILINK_STATUS_FAILURE = "POST_ILINK_STATUS_FAILURE";

// DEVICES
export const GET_DEVICES_REQUEST = "GET_DEVICES_REQUEST";
export const GET_DEVICES_SUCCESS = "GET_DEVICES_SUCCESS";
export const GET_DEVICES_FAILURE = "GET_DEVICES_FAILURE";
export const POST_DEVICES_REQUEST = "POST_DEVICES_REQUEST";
export const POST_DEVICES_SUCCESS = "POST_DEVICES_SUCCESS";
export const POST_DEVICES_FAILURE = "POST_DEVICES_FAILURE";
export const ADD_PREVIEW_DEVICES = 'ADD_PREVIEW_DEVICES';
export const REMOVE_PREVIEW_DEVICES = 'REMOVE_PREVIEW_DEVICES';


// Locations
export const GET_LOCATIONS_REQUEST = "GET_LOCATIONS_REQUEST";
export const GET_LOCATIONS_SUCCESS = "GET_LOCATIONS_SUCCESS";
export const GET_LOCATIONS_FAILURE = "GET_LOCATIONS_FAILURE";
export const POST_LOCATIONS_REQUEST = "POST_LOCATIONS_REQUEST";
export const POST_LOCATIONS_SUCCESS = "POST_LOCATIONS_SUCCESS";
export const POST_LOCATIONS_FAILURE = "POST_LOCATIONS_FAILURE";
export const ADD_PREVIEW_LOCATIONS = 'ADD_PREVIEW_LOCATIONS';
export const REMOVE_PREVIEW_LOCATIONS = 'REMOVE_PREVIEW_LOCATIONS';

// REgions
export const GET_REGIONS_REQUEST = "GET_REGIONS_REQUEST";
export const GET_REGIONS_SUCCESS = "GET_REGIONS_SUCCESS";
export const GET_REGIONS_FAILURE = "GET_REGIONS_FAILURE";
export const POST_REGIONS_REQUEST = "POST_REGIONS_REQUEST";
export const POST_REGIONS_SUCCESS = "POST_REGIONS_SUCCESS";
export const POST_REGIONS_FAILURE = "POST_REGIONS_FAILURE";
export const ADD_PREVIEW_REGIONS = 'ADD_PREVIEW_REGIONS';
export const REMOVE_PREVIEW_REGIONS = 'REMOVE_PREVIEW_REGIONS';


// Modems
export const GET_MODEMS_REQUEST = "GET_MODEMS_REQUEST";
export const GET_MODEMS_SUCCESS = "GET_MODEMS_SUCCESS";
export const GET_MODEMS_FAILURE = "GET_MODEMS_FAILURE";
export const POST_MODEMS_REQUEST = "POST_MODEMS_REQUEST";
export const POST_MODEMS_SUCCESS = "POST_MODEMS_SUCCESS";
export const POST_MODEMS_FAILURE = "POST_MODEMS_FAILURE";
export const ADD_PREVIEW_MODEMS = 'ADD_PREVIEW_MODEMS';
export const REMOVE_PREVIEW_MODEMS = 'REMOVE_PREVIEW_MODEMS';


//Report

export const GET_REPORTDATA_REQUEST = "GET_REPORTDATA_REQUEST";
export const GET_REPORTDATA_SUCCESS = "GET_REPORTDATA_SUCCESS";
export const GET_REPORTDATA_FAILURE = "GET_REPORTDATA_FAILURE";
export const GENERATE_DATA_REQUEST = "GENERATE_DATA_REQUEST";
export const GENERATE_DATA_SUCCESS = "GENERATE_DATA_SUCCESS";
export const GENERATE_DATA_FAILURE = "GENERATE_DATA_FAILURE";
export const SET_SELECTED_USER = "SET_SELECTED_USER";
export const REMOVE_SELECTED_USER = "REMOVE_SELECTED_USER";
export const GET_VENTILATOR_LIST_REQUEST = "GET_VENTILATOR_LIST_REQUEST";
export const GET_VENTILATOR_LIST_SUCCESS = "GET_VENTILATOR_LIST_SUCCESS";
export const GET_VENTILATOR_LIST_FAILURE = "GET_VENTILATOR_LIST_FAILURE";
export const GET_AGGREGATE_OPTIONS_LIST_REPORT_REQUEST = "GET_AGGREGATE_OPTIONS_LIST_REPORT_REQUEST";
export const GET_AGGREGATE_OPTIONS_LIST_REPORT_SUCCESS = "GET_AGGREGATE_OPTIONS_LIST_REPORT_SUCCESS";
export const GET_AGGREGATE_OPTIONS_LIST_REPORT_FAILURE = "GET_AGGREGATE_OPTIONS_LIST_REPORT_FAILURE";


//features

export const GET_FEATURES_REQUEST = "GET_FEATURES_REQUEST";
export const GET_FEATURES_SUCCESS = "GET_FEATURES_SUCCESS";
export const GET_FEATURES_FAILURE = "GET_FEATURES_FAILURE";
export const POST_FEATURES_REQUEST = "POST_FEATURES_REQUEST";
export const POST_FEATURES_SUCCESS = "POST_FEATURES_SUCCESS";
export const POST_FEATURES_FAILURE = "POST_FEATURES_FAILURE";

//customer info
export const GET_CUSTOMER_INFO_REQUEST = "GET_CUSTOMER_INFO_REQUEST";
export const GET_CUSTOMER_INFO_SUCCESS = "GET_CUSTOMER_INFO_SUCCESS";
export const GET_CUSTOMER_INFO_FAILURE = "GET_CUSTOMER_INFO_FAILURE";
export const GET_CUSTOMER_SUMMARY_REQUEST = "GET_CUSTOMER_SUMMARY_REQUEST";
export const GET_CUSTOMER_SUMMARY_SUCCESS = "GET_CUSTOMER_SUMMARY_SUCCESS";
export const GET_CUSTOMER_SUMMARY_FAILURE = "GET_CUSTOMER_SUMMARY_FAILURE";

// customer insurance

export const GET_CUSTOMER_INSURANCE_REQUEST = "GET_CUSTOMER_INSURANCE_REQUEST";
export const GET_CUSTOMER_INSURANCE_SUCCESS = "GET_CUSTOMER_INSURANCE_SUCCESS";
export const GET_CUSTOMER_INSURANCE_FAILURE = "GET_CUSTOMER_INSURANCE_FAILURE";
export const POST_CUSTOMER_INSURANCE_REQUEST = "POST_CUSTOMER_INSURANCE_REQUEST";
export const POST_CUSTOMER_INSURANCE_SUCCESS = "POST_CUSTOMER_INSURANCE_SUCCESS";
export const POST_CUSTOMER_INSURANCE_FAILURE = "POST_CUSTOMER_INSURANCE_FAILURE";
export const ADD_PREVIEW_CUSTOMER_INSURANCE = 'ADD_PREVIEW_CUSTOMER_INSURANCE';
export const REMOVE_PREVIEW_CUSTOMER_INSURANCE = 'REMOVE_PREVIEW_CUSTOMER_INSURANCE';

// Users
export const GET_USERS_REQUEST = "GET_USERS_REQUEST";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILURE = "GET_USERS_FAILURE";
export const POST_USERS_REQUEST = "POST_USERS_REQUEST";
export const POST_USERS_SUCCESS = "POST_USERS_SUCCESS";
export const POST_USERS_FAILURE = "POST_USERS_FAILURE";
export const ADD_PREVIEW_USERS = 'ADD_PREVIEW_USERS';
export const REMOVE_PREVIEW_USERS = 'REMOVE_PREVIEW_USERS';
export const GET_USER_ROLES_REQUEST = 'GET_USER_ROLES_REQUEST';
export const GET_USER_ROLES_SUCCESS = 'GET_USER_ROLES_SUCCESS';
export const GET_USER_ROLES_FAILURE = 'GET_USER_ROLES_FAILURE';

// global-features
export const GET_GLOBAL_FEATURES_REQUEST = "GET_GLOBAL_FEATURES_REQUEST";
export const GET_GLOBAL_FEATURES_SUCCESS = "GET_GLOBAL_FEATURES_SUCCESS";
export const GET_GLOBAL_FEATURES_FAILURE = "GET_GLOBAL_FEATURES_FAILURE";

export const GET_COUNTRY_FEATURES_REQUEST = "GET_COUNTRY_FEATURES_REQUEST";
export const GET_COUNTRY_FEATURES_SUCCESS = "GET_COUNTRY_FEATURES_SUCCESS";
export const GET_COUNTRY_FEATURES_FAILURE = "GET_COUNTRY_FEATURES_FAILURE";

export const GET_COUNTRY_LIST_REQUEST = "GET_COUNTRY_LIST_REQUEST";
export const GET_COUNTRY_LIST_SUCCESS = "GET_COUNTRY_LIST_SUCCESS";
export const GET_COUNTRY_LIST_FAILURE = "GET_COUNTRY_LIST_FAILURE";

export const GET_LANGUAGE_LIST_REQUEST = "GET_LANGUAGE_LIST_REQUEST";
export const GET_LANGUAGE_LIST_SUCCESS = "GET_LANGUAGE_LIST_SUCCESS";
export const GET_LANGUAGE_LIST_FAILURE = "GET_LANGUAGE_LIST_FAILURE";

export const POST_NEW_CUSTOMER_REQUEST = "POST_NEW_CUSTOMER_REQUEST";
export const POST_NEW_CUSTOMER_SUCCESS = "POST_NEW_CUSTOMER_SUCCESS";
export const POST_NEW_CUSTOMER_FAILURE = "POST_NEW_CUSTOMER_FAILURE";
export const RESET_NEW_CUSTOMER_MESSAGE = "RESET_NEW_CUSTOMER_MESSAGE";

export const GET_GLOBAL_ILINK_FIRMWARE_REQUEST = "GET_GLOBAL_ILINK_FIRMWARE_REQUEST";
export const GET_GLOBAL_ILINK_FIRMWARE_SUCCESS = "GET_GLOBAL_ILINK_FIRMWARE_SUCCESS";
export const GET_GLOBAL_ILINK_FIRMWARE_FAILURE = "GET_GLOBAL_ILINK_FIRMWARE_FAILURE";

export const GET_GLOBAL_ILINK_FIRMWARE_VERSIONS_REQUEST = "GET_GLOBAL_ILINK_FIRMWARE_VERSIONS_REQUEST";
export const GET_GLOBAL_ILINK_FIRMWARE_VERSIONS_SUCCESS = "GET_GLOBAL_ILINK_FIRMWARE_VERSIONS_SUCCESS";
export const GET_GLOBAL_ILINK_FIRMWARE_VERSIONS_FAILURE = "GET_GLOBAL_ILINK_FIRMWARE_VERSIONS_FAILURE";

export const POST_GLOBAL_ILINK_FIRMWARE_REQUEST = "POST_GLOBAL_ILINK_FIRMWARE_REQUEST";
export const POST_GLOBAL_ILINK_FIRMWARE_SUCCESS = "POST_GLOBAL_ILINK_FIRMWARE_SUCCESS";
export const POST_GLOBAL_ILINK_FIRMWARE_FAILURE = "POST_GLOBAL_ILINK_FIRMWARE_FAILURE";

export const SET_SELECTED_FEATURE_LEVEL = "SET_SELECTED_FEATURE_LEVEL";
export const SET_SELECTED_COUNTRY = "SET_SELECTED_COUNTRY";

export const SET_SELECTED_FEATURES = "SET_SELECTED_FEATURES";

export const POST_GLOBAL_FEATURES_REQUEST = "POST_GLOBAL_FEATURES_REQUEST";
export const POST_GLOBAL_FEATURES_SUCCESS = "POST_GLOBAL_FEATURES_SUCCESS";
export const POST_GLOBAL_FEATURES_FAILURE = "POST_GLOBAL_FEATURES_FAILURE";

export const SET_SELECTED_MODEMS = "SET_SELECTED_MODEMS";
export const SET_SELECTED_FIRMWARE_VERSION = "SET_SELECTED_FIRMWARE_VERSION";

export const GET_GLOBAL_REASSIGN_MODEM_REQUEST = "GET_GLOBAL_REASSIGN_MODEM_REQUEST";
export const GET_GLOBAL_REASSIGN_MODEM_SUCCESS = "GET_GLOBAL_REASSIGN_MODEM_SUCCESS";
export const GET_GLOBAL_REASSIGN_MODEM_FAILURE = "GET_GLOBAL_REASSIGN_MODEM_FAILURE";

export const GET_GLOBAL_REASSIGN_MODEM_ACCOUNTS_REQUEST = "GET_GLOBAL_REASSIGN_MODEM_ACCOUNTS_REQUEST";
export const GET_GLOBAL_REASSIGN_MODEM_ACCOUNTS_SUCCESS = "GET_GLOBAL_REASSIGN_MODEM_ACCOUNTS_SUCCESS";
export const GET_GLOBAL_REASSIGN_MODEM_ACCOUNTS_FAILURE = "GET_GLOBAL_REASSIGN_MODEM_ACCOUNTS_FAILURE";

export const POST_GLOBAL_REASSIGN_MODEM_REQUEST = "POST_GLOBAL_REASSIGN_MODEM_REQUEST";
export const POST_GLOBAL_REASSIGN_MODEM_SUCCESS = "POST_GLOBAL_REASSIGN_MODEM_SUCCESS";
export const POST_GLOBAL_REASSIGN_MODEM_FAILURE = "POST_GLOBAL_REASSIGN_MODEM_FAILURE";

export const ADD_PREVIEW_REASSIGN_MODEMS = "ADD_PREVIEW_REASSIGN_MODEMS";
export const REMOVE_PREVIEW_REASSIGN_MODEMS = "REMOVE_PREVIEW_REASSIGN_MODEMS";

export const SET_GLOBAL_REASSIGN_SELECTED_MODEMS = "SET_GLOBAL_REASSIGN_SELECTED_MODEMS";
export const SET_GLOBAL_REASSIGN_SELECTED_ACCOUNT = "SET_GLOBAL_REASSIGN_SELECTED_ACCOUNT";

export const GET_GLOBAL_REASSIGN_DEVICE_REQUEST = "GET_GLOBAL_REASSIGN_DEVICE_REQUEST";
export const GET_GLOBAL_REASSIGN_DEVICE_SUCCESS = "GET_GLOBAL_REASSIGN_DEVICE_SUCCESS";
export const GET_GLOBAL_REASSIGN_DEVICE_FAILURE = "GET_GLOBAL_REASSIGN_DEVICE_FAILURE";

export const GET_GLOBAL_REASSIGN_DEVICE_ACCOUNTS_REQUEST = "GET_GLOBAL_REASSIGN_DEVICE_ACCOUNTS_REQUEST";
export const GET_GLOBAL_REASSIGN_DEVICE_ACCOUNTS_SUCCESS = "GET_GLOBAL_REASSIGN_DEVICE_ACCOUNTS_SUCCESS";
export const GET_GLOBAL_REASSIGN_DEVICE_ACCOUNTS_FAILURE = "GET_GLOBAL_REASSIGN_DEVICE_ACCOUNTS_FAILURE";

export const POST_GLOBAL_REASSIGN_DEVICE_REQUEST = "POST_GLOBAL_REASSIGN_DEVICE_REQUEST";
export const POST_GLOBAL_REASSIGN_DEVICE_SUCCESS = "POST_GLOBAL_REASSIGN_DEVICE_SUCCESS";
export const POST_GLOBAL_REASSIGN_DEVICE_FAILURE = "POST_GLOBAL_REASSIGN_DEVICE_FAILURE";

export const ADD_PREVIEW_REASSIGN_DEVICE = "ADD_PREVIEW_REASSIGN_DEVICE";
export const REMOVE_PREVIEW_REASSIGN_DEVICE = "REMOVE_PREVIEW_REASSIGN_DEVICE";


export const SET_GLOBAL_REASSIGN_SELECTED_DEVICES = "SET_GLOBAL_REASSIGN_SELECTED_DEVICES";
//export const SET_GLOBAL_REASSIGN_SELECTED_ACCOUNT = "SET_GLOBAL_REASSIGN_SELECTED_ACCOUNT";

export const GET_AGGREGATE_OPTIONS_LIST_REQUEST = "GET_AGGREGATE_OPTIONS_LIST_REQUEST";
export const GET_AGGREGATE_OPTIONS_LIST_SUCCESS = "GET_AGGREGATE_OPTIONS_LIST_SUCCESS";
export const GET_AGGREGATE_OPTIONS_LIST_FAILURE = "GET_AGGREGATE_OPTIONS_LIST_FAILURE";


export const POST_AGGREGATE_OPTIONS_REQUEST = "POST_AGGREGATE_OPTIONS_REQUEST";
export const POST_AGGREGATE_OPTIONS_SUCCESS = "POST_AGGREGATE_OPTIONS_SUCCESS";
export const POST_AGGREGATE_OPTIONS_FAILURE = "POST_AGGREGATE_OPTIONS_FAILURE";

export const GET_ACCOUNT_LIST_REQUEST = "GET_ACCOUNT_LIST_REQUEST";
export const GET_ACCOUNT_LIST_SUCCESS = "GET_ACCOUNT_LIST_SUCCESS";
export const GET_ACCOUNT_LIST_FAILURE = "GET_ACCOUNT_LIST_FAILURE";

export const GET_USER_LIST_REQUEST = "GET_USER_LIST_REQUEST";
export const GET_USER_LIST_SUCCESS = "GET_USER_LIST_SUCCESS";
export const GET_USER_LIST_FAILURE = "GET_USER_LIST_FAILURE";

export const GET_PATIENT_LIST_REQUEST = "GET_PATIENT_LIST_REQUEST";
export const GET_PATIENT_LIST_SUCCESS = "GET_PATIENT_LIST_SUCCESS";
export const GET_PATIENT_LIST_FAILURE = "GET_PATIENT_LIST_FAILURE";

export const POST_UPLOAD_DATA_REQUEST = "POST_UPLOAD_DATA_REQUEST";
export const POST_UPLOAD_DATA_SUCCESS = "POST_UPLOAD_DATA_SUCCESS";
export const POST_UPLOAD_DATA_FAILURE = "POST_UPLOAD_DATA_FAILURE";

export const PROCESS_UPLOAD_DATA_FILE_REQUEST = "PROCESS_UPLOAD_DATA_FILE_REQUEST";
export const PROCESS_UPLOAD_DATA_FILE_SUCCESS = "PROCESS_UPLOAD_DATA_FILE_SUCCESS";
export const PROCESS_UPLOAD_DATA_FILE_FAILURE = "PROCESS_UPLOAD_DATA_FILE_FAILURE";

export const GET_REPORT_DOWNLOAD_DATA_REQUEST = "GET_REPORT_DOWNLOAD_DATA_REQUEST";
export const GET_REPORT_DOWNLOAD_DATA_SUCCESS = "GET_REPORT_DOWNLOAD_DATA_SUCCESS";
export const GET_REPORT_DOWNLOAD_DATA_FAILURE = "GET_REPORT_DOWNLOAD_DATA_FAILURE";